// Contact-field helpers shared across list / card / detail surfaces, so the "which phone/email is
// the primary one" logic lives in exactly one place. Follows the candidate model:
//   candidate.phoneNumbers = [{ number, type: mobile|office|home, isPrimary }]  // one axis: the type IS the context
//   candidate.emails       = [{ address, label: business|personal, isPrimary }]
// with legacy single-value fallbacks candidate.phone / candidate.email.

const PHONE_TYPE_ORDER = { mobile: 0, mobilePrivate: 1, office: 2, home: 3 };
const EMAIL_LABEL_ORDER = { business: 0, personal: 1 };

/** Phones ordered: the explicit primary first, then mobile → office → home. */
export function sortedPhones(candidate) {
  const phones = candidate?.phoneNumbers ?? [];
  if (!phones.length) return [];
  return [...phones].sort((a, b) => {
    if (!!a.isPrimary !== !!b.isPrimary) return a.isPrimary ? -1 : 1;
    return (PHONE_TYPE_ORDER[a.type] ?? 9) - (PHONE_TYPE_ORDER[b.type] ?? 9);
  });
}

/** Emails ordered: the explicit primary first, then business → personal. */
export function sortedEmails(candidate) {
  const emails = candidate?.emails ?? [];
  if (!emails.length) return [];
  return [...emails].sort((a, b) => {
    if (!!a.isPrimary !== !!b.isPrimary) return a.isPrimary ? -1 : 1;
    return (EMAIL_LABEL_ORDER[a.label] ?? 9) - (EMAIL_LABEL_ORDER[b.label] ?? 9);
  });
}

/** The one phone to surface in a compact space (list row, card). null when there is none. */
export function primaryPhone(candidate) {
  const p = sortedPhones(candidate)[0];
  if (p) return p;
  return candidate?.phone ? { number: candidate.phone, type: "office" } : null;
}

/** The one email to surface in a compact space. null when there is none. */
export function primaryEmail(candidate) {
  const e = sortedEmails(candidate)[0];
  if (e) return e;
  return candidate?.email ? { address: candidate.email, label: "business" } : null;
}
